// extracted by mini-css-extract-plugin
export default {"alert":"MySolutionsChoose_alert__sfL19","alert_header":"MySolutionsChoose_alert_header__D+cow","group_label":"MySolutionsChoose_group_label__-lBFn"};